import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircleIcon } from "@phosphor-icons/react";

export default function BillingCancel() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-8" data-testid="billing-cancel-page">
      <div className="bg-white border border-slate-300 rounded-sm p-10 max-w-md w-full text-center">
        <XCircleIcon size={56} weight="fill" className="mx-auto text-slate-400 mb-3" />
        <div className="section-eyebrow text-slate-500 mb-1">/// Cancelled</div>
        <div className="font-display text-2xl font-black mb-2">No charge yet</div>
        <div className="text-sm text-slate-600 mb-5">
          Checkout was cancelled. You can pick a plan any time from Settings → Billing.
        </div>
        <Link to="/settings"><Button className="rounded-sm w-full" data-testid="billing-cancel-back">Back to Settings</Button></Link>
      </div>
    </div>
  );
}
